"use strict";
"use client";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { Popover } from '@ark-ui/react/popover';
export { PopoverContext as Context } from '@ark-ui/react/popover';
import { withSlotScopeClasses } from '../../helpers/scoped-slots.mjs';
import { tv } from 'tailwind-variants';
import { createSlotRecipeContext } from './utils/create-slot-recipe-context.mjs';

const popoverRecipe = tv({
  slots: withSlotScopeClasses("popover", {
    positioner: "relative",
    content: [
      "bg-bg-default rounded-md shadow-lg flex flex-col max-w-sm z-popover p-4",
      "data-[state=open]:animate-[fadeIn_0.25s_ease-out]",
      "data-[state=closed]:animate-[fadeOut_0.2s_ease-out]",
      "[&[hidden]]:hidden"
    ],
    title: "font-medium text-sm leading-5",
    description: "text-fg-muted text-sm leading-5",
    closeTrigger: "appearance-none bg-transparent cursor-pointer align-middle text-fg-muted",
    arrow: "[--arrow-size:0.75rem] [--arrow-background:var(--iap-colors-bg-default)]",
    arrowTip: "border-t border-l",
    anchor: "",
    indicator: "",
    trigger: "appearance-none bg-transparent cursor-pointer align-middle"
  })
});
const { withRootProvider, withContext } = createSlotRecipeContext(popoverRecipe);
withRootProvider(
  Popover.RootProvider
);
const Root = withRootProvider(Popover.Root);
const Anchor = withContext(Popover.Anchor, "anchor");
withContext(Popover.Arrow, "arrow");
withContext(
  Popover.ArrowTip,
  "arrowTip"
);
withContext(
  Popover.CloseTrigger,
  "closeTrigger"
);
const Content = withContext(
  Popover.Content,
  "content"
);
withContext(
  Popover.Description,
  "description"
);
withContext(
  Popover.Indicator,
  "indicator"
);
const Positioner = withContext(
  Popover.Positioner,
  "positioner"
);
const Title = withContext(Popover.Title, "title");
const Trigger = withContext(
  Popover.Trigger,
  "trigger"
);

export { Anchor, Content, Positioner, Root, Title, Trigger };
